export interface User {
    _id?: string;
    firstname: string;
    lastname: string;
    photo?: string;
    poste: string;
    telephone: string;
    fichecontact: string;
    email: string;
    lien1: string;
    lien2: string;
    lien3: string;
    cardurl?: string;
    role?: number;
}

export interface UserTableProps {
    users: User[];
    confirmDeleteHandler?: () => Promise<void>;
    deleteUserHandler?: (id: string) => Promise<void>;
    showDeleteModal?: boolean;
    setShowDeleteModal?: (show: boolean) => void;
    onUserAdded?: (user: User) => void;
    updateUserHandler?: (id: string, user: User) => void;
    setIsShowUpdateModal?: (show: boolean) => void;
    isShowUpdateModal?: boolean;
    setUsersObject?:(Users: User[]) => void; 
}

export enum UserFields {
    firstname = 'firstname',
    lastname = 'lastname',
    photo = 'photo',
    poste = 'poste',
    telephone = 'telephone',
    fichecontact = 'fichecontact',
    email = 'email',
    lien1 = 'lien1',
    lien2 = 'lien2',
    lien3 = 'lien3',
    cardurl = 'cardurl'
}